import { animate, timeline as timeline2, stagger } from "//home-cooks.co.uk/cdn/shop/t/143/assets/vendor.min.js?v=161072099565793977701707219051";
(function (window, k) {
    $(document).ready(function() {
        $('#recover #loginButton').on('click', function() {
            var $button = $(this);
            var $contentElement = $button.find('div');
            var $animationElement = $button.find('.button__loader');
            timeline2([
                [$contentElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
                [$animationElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
            ]);
            animate($animationElement.children().get(), { opacity: [1, 0.1] }, { duration: 0.35, delay: stagger(0.35 / 3), direction: "alternate", repeat: Infinity });
            var $form = $('#recover form');

            $('#recoverMessageEmail').show();

            setTimeout(function() {
                $form.off('submit').submit();
            }, 5000);
        });
    });
})(window);